// @flow
import type { List } from 'immutable';
import { getProductIndexById } from './selectors';

export const undoable = (reducer: any) => (state: any, action: any) => {
    const index = getProductIndexById(state, action.payload.productId);

    return {
        ...reducer(state, action),
        previous: state.previous.set(action.type, [index, state.productItems.get(index)])
    };
};

export const filterOutDeviceGroups = (products: List<*>): List<*> => products.filter(p => !p.isGroup);



// WEBPACK FOOTER //
// ./src/core/state/products/utils.js